import { render, staticRenderFns } from "./yjorder.vue?vue&type=template&id=640cba92&scoped=true"
import script from "./yjorder.vue?vue&type=script&lang=js"
export * from "./yjorder.vue?vue&type=script&lang=js"
import style0 from "./yjorder.vue?vue&type=style&index=0&id=640cba92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640cba92",
  null
  
)

export default component.exports